/**
 * creation-limit-store — drives the single global <CreationLimitDialog/> mounted
 * in AppShell.
 *
 * Both surfaces of the per-app creation cap push into the same store:
 *  - pre-check  (useOpenAppModal Branch 2 → checkCreationLimit → show)
 *  - save-error (useSmallAppSave / duplicateAsset catch → mapCreationLimitError → show)
 *
 * One dialog, one source of truth — no per-mount dialog copies. Memory-only
 * (transient UI state), so it is intentionally NOT persisted.
 */
import { create } from 'zustand';
import type { CreationLimitNotice } from '../utils/app-creation-limit';

interface CreationLimitState {
  /** Non-null opens the dialog; null keeps it closed. */
  notice: CreationLimitNotice | null;
  /** Open the dialog with the given notice. */
  show: (notice: CreationLimitNotice) => void;
  /** Dismiss the dialog. */
  close: () => void;
}

export const useCreationLimitStore = create<CreationLimitState>((set) => ({
  notice: null,
  show: (notice) => set({ notice }),
  close: () => set({ notice: null }),
}));
